import Vue from "vue";

export default {
  namespaced: true,
  state: () => {
    return {
      dialog: {
        directionSelect: false,
        signIn: false,
        notify: false,
        playView: false,
      },
      notifyData: {
        title: "",
        text: "",
        btnText: "",
        isConfirm: false,
      },
      playViewMachine: null,
    };
  },
  getters: {
    getDialog: (state) => {
      return state.dialog;
    },
    getNotifyData: (state) => {
      return state.notifyData;
    },
    getPlayViewMachine: (state) => {
      return state.playViewMachine;
    },
  },
  mutations: {
    setDialog(state, value) {
      Vue.set(state, "dialog", { ...state.dialog, ...value });
    },
    setNotifyMessage(state, message) {
      Vue.set(state, "notifyData", message);
      Vue.set(state, "dialog", { ...state.dialog, notify: true });
    },
    setDirectionSelectData(state, data) {
      Vue.set(state, "directionSelectData", data);
    },
    setPlayViewMachine(state, machine) {
      Vue.set(state, "playViewMachine", machine);
    },
  },
};
